import { MutationOptions, useMutation } from '@tanstack/react-query';
import { useToast } from '@givebutter/primitives/toast';
import { updateActivity } from 'api/contacts/activities';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useCurrentContact } from 'customHooks/useCurrentContact';
import { accountQueryKeys } from 'queries/account-query-keys';
import { queryClient } from 'queries/queryClient';
import { GivebutterAxiosError } from 'types/error';

interface UseSaveNoteParams {
    activityId: number;
    note: string;
}

const useSaveNote = (
    options: MutationOptions<unknown, GivebutterAxiosError, UseSaveNoteParams> = {},
) => {
    const { onSuccess, ...restOptions } = options;
    const { accountId } = useCurrentAccount();
    const { data: contact } = useCurrentContact();
    const message = useToast();

    return useMutation<unknown, GivebutterAxiosError, UseSaveNoteParams>({
        mutationFn: ({ activityId, note }) =>
            updateActivity(accountId, contact.id, {
                activityId,
                data: { note },
            }),
        onSuccess: (data, vars, ctx) => {
            queryClient.invalidateQueries({
                queryKey: accountQueryKeys.contactActivities(accountId, contact.id),
            });
            message.success('Saved activity item note!');
            onSuccess?.(data, vars, ctx);
        },
        onError: error => {
            message.error(error.response?.data.message ?? 'Unknown error occurred');
        },
        ...restOptions,
    });
};

export type { UseSaveNoteParams };
export { useSaveNote };
